import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
  SparePartSearchSummary,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

export interface SearchSparePartsByNamesArgs {
  sellerId: string;
  manufacturerReference: string;
  manufacturerName: string;
  supplierReference: string;
  supplierName: string;
  stockName: string;
}

export const searchSparePartsByNames = async ({
  manufacturerName,
  supplierName,
  supplierReference,
  manufacturerReference,
  sellerId,
  stockName,
}: SearchSparePartsByNamesArgs): Promise<
  BackResponse<SparePartSearchSummary[]> | BackResponseFailure
> => {
  try {
    return await apiCall<BackResponse<SparePartSearchSummary[]>>(
      buildUrl(`${APIConfiguration.sparePart}parts/searchbynames`, {
        manufacturerName,
        supplierName,
        supplierReference,
        manufacturerReference,
        sellerId,
        stockName,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
